import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=638ae3fc&scoped=true&xmlns%3Av-hammer=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./Carousel.vue?vue&type=script&lang=js&"
export * from "./Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=638ae3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ae3fc",
  null
  
)

export default component.exports